/* GENERATED from the original artifact template by
 * tools/convert-template.py. Structure and inline styles are the
 * artifact's; edits since generation are tracked in git. */
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import type { LoginVals } from '@/lib/vals/login';

export function LoginRoute({ v }: { v: LoginVals }) {
  return (
    <>
      <div
        style={{
          minHeight: '100vh',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 420px), 1fr))',
          background: 'var(--wft-bg-0)',
        }}
      >
        <div
          style={{
            borderRight: '1px solid var(--wft-line)',
            background: 'var(--wft-bg-sunk)',
            padding: '32px 40px 40px',
            display: 'flex',
            flexDirection: 'column',
            gap: '40px',
          }}
        >
          <Link to="/" style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
            <span
              style={{
                fontFamily: 'var(--wft-display)',
                fontWeight: '700',
                fontSize: '15px',
                letterSpacing: '0.16em',
                color: 'var(--wft-ink-0)',
              }}
            >
              World Finance Terminal
            </span>{' '}
            <span
              style={{
                fontFamily: 'var(--wft-mono)',
                fontSize: '9.5px',
                letterSpacing: '0.14em',
                textTransform: 'uppercase',
                color: 'var(--wft-ink-3)',
              }}
            >
              by GodEngine
            </span>
          </Link>{' '}
          <div style={{ margin: 'auto 0' }}>
            <h2
              style={{
                fontFamily: 'var(--wft-display)',
                fontWeight: '600',
                fontSize: 'clamp(24px, 2.6vw, 36px)',
                lineHeight: '1.08',
                letterSpacing: '-0.02em',
                margin: '0 0 18px',
                maxWidth: '22ch',
              }}
            >
              You are signing into a terminal, not a dashboard.
            </h2>{' '}
            <p
              style={{
                fontSize: '14.5px',
                lineHeight: '1.65',
                color: 'var(--wft-ink-1)',
                maxWidth: '46ch',
                margin: '0 0 26px',
              }}
            >
              Twenty sections behind a rail, a command bar with mnemonics, engine columns beside
              observed ones, and panels that name the connector they are missing.
            </p>{' '}
            <div
              style={{
                border: '1px solid var(--wft-line)',
                borderRadius: '3px',
                background: 'var(--wft-bg-1)',
                marginBottom: '20px',
              }}
            >
              <div
                style={{
                  height: '26px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '0 10px',
                  background: 'var(--wft-bg-sunk)',
                  borderBottom: '1px solid var(--wft-line)',
                }}
              >
                <span
                  style={{
                    fontFamily: 'var(--wft-mono)',
                    fontSize: '10.5px',
                    letterSpacing: '0.09em',
                    textTransform: 'uppercase',
                    color: 'var(--wft-ink-1)',
                  }}
                >
                  Sessions
                </span>{' '}
                <span
                  style={{
                    marginLeft: 'auto',
                    fontFamily: 'var(--wft-mono)',
                    fontSize: '9.5px',
                    color: 'var(--wft-live)',
                  }}
                >
                  DERIVED · LIVE
                </span>
              </div>{' '}
              <div style={{ padding: '8px 10px' }}>
                {(v.sessions ?? []).map((s, sIndex) => (
                  <Fragment key={sIndex}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '3px 0',
                      }}
                    >
                      <span
                        style={{
                          width: '6px',
                          height: '6px',
                          borderRadius: '50%',
                          background: s.color,
                        }}
                      ></span>{' '}
                      <span
                        style={{
                          fontFamily: 'var(--wft-mono)',
                          fontSize: '12px',
                          color: 'var(--wft-ink-1)',
                        }}
                      >
                        {s.city}
                      </span>{' '}
                      <span
                        style={{
                          marginLeft: 'auto',
                          fontFamily: 'var(--wft-mono)',
                          fontVariantNumeric: 'tabular-nums',
                          fontSize: '12px',
                          color: 'var(--wft-ink-0)',
                        }}
                      >
                        {s.hm}
                      </span>{' '}
                      <span
                        style={{
                          width: '54px',
                          textAlign: 'right',
                          fontFamily: 'var(--wft-mono)',
                          fontSize: '9.5px',
                          textTransform: 'uppercase',
                          color: 'var(--wft-ink-3)',
                        }}
                      >
                        {s.state}
                      </span>
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>{' '}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {(v.chips ?? []).map((c, cIndex) => (
                <Fragment key={cIndex}>
                  <span
                    style={{
                      fontFamily: 'var(--wft-mono)',
                      fontSize: '9.5px',
                      letterSpacing: '0.08em',
                      textTransform: 'uppercase',
                      color: 'var(--wft-ink-2)',
                      border: '1px solid var(--wft-line)',
                      borderRadius: '3px',
                      padding: '5px 9px',
                    }}
                  >
                    {c}
                  </span>
                </Fragment>
              ))}
            </div>
          </div>{' '}
          <p
            style={{
              fontFamily: 'var(--wft-mono)',
              fontSize: '9.5px',
              lineHeight: '1.7',
              color: 'var(--wft-ink-3)',
              margin: '0',
            }}
          >
            Authentication has no endpoint in the repository. This screen is the design for it and
            gates the demo in the browser only — nothing is transmitted.
          </p>
        </div>{' '}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px 24px',
          }}
        >
          <form onSubmit={v.submit} style={{ width: '100%', maxWidth: '380px' }} noValidate>
            <p
              style={{
                fontFamily: 'var(--wft-mono)',
                fontSize: '10.5px',
                letterSpacing: '0.2em',
                textTransform: 'uppercase',
                color: 'var(--wft-accent)',
                margin: '0 0 14px',
              }}
            >
              Sign in
            </p>{' '}
            <h1
              style={{
                fontFamily: 'var(--wft-display)',
                fontWeight: '600',
                fontSize: '28px',
                letterSpacing: '-0.02em',
                margin: '0 0 28px',
              }}
            >
              Open the terminal
            </h1>{' '}
            <label
              htmlFor="wft-email"
              style={{
                display: 'block',
                fontFamily: 'var(--wft-mono)',
                fontSize: '10.5px',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                color: 'var(--wft-ink-2)',
                marginBottom: '7px',
              }}
            >
              Email
            </label>{' '}
            <input
              id="wft-email"
              name="email"
              type="email"
              autoComplete="username"
              value={v.email}
              onInput={v.onEmail}
              placeholder="you@desk.example"
              style={{
                width: '100%',
                background: 'var(--wft-bg-3)',
                border: '1px solid var(--wft-line)',
                borderRadius: '3px',
                padding: '11px 12px',
                fontFamily: 'var(--wft-mono)',
                fontSize: '13px',
                color: 'var(--wft-ink-0)',
                marginBottom: '18px',
              }}
              className="wft-i8"
            />{' '}
            <label
              htmlFor="wft-pw"
              style={{
                display: 'block',
                fontFamily: 'var(--wft-mono)',
                fontSize: '10.5px',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                color: 'var(--wft-ink-2)',
                marginBottom: '7px',
              }}
            >
              Password
            </label>{' '}
            <input
              id="wft-pw"
              name="password"
              type="password"
              autoComplete="current-password"
              value={v.password}
              onInput={v.onPassword}
              placeholder="••••••••"
              style={{
                width: '100%',
                background: 'var(--wft-bg-3)',
                border: '1px solid var(--wft-line)',
                borderRadius: '3px',
                padding: '11px 12px',
                fontFamily: 'var(--wft-mono)',
                fontSize: '13px',
                color: 'var(--wft-ink-0)',
                marginBottom: '14px',
              }}
              className="wft-i8"
            />{' '}
            {v.hasError ? (
              <>
                <p
                  role="alert"
                  style={{
                    fontFamily: 'var(--wft-mono)',
                    fontSize: '11px',
                    lineHeight: '1.6',
                    color: 'var(--wft-down)',
                    background: 'var(--wft-down-bg)',
                    border: '1px solid var(--wft-down)',
                    borderRadius: '3px',
                    padding: '9px 11px',
                    margin: '0 0 14px',
                  }}
                >
                  {v.errorText}
                </p>
              </>
            ) : null}{' '}
            <button
              type="submit"
              style={{
                width: '100%',
                fontFamily: 'var(--wft-mono)',
                fontSize: '12px',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                fontWeight: '500',
                padding: '13px',
                border: 'none',
                borderRadius: '3px',
                background: 'var(--wft-accent)',
                color: 'var(--wft-bg-0)',
                cursor: 'pointer',
              }}
              className="wft-i3"
            >
              {v.buttonLabel}
            </button>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '12px',
                marginTop: '16px',
              }}
            >
              <Link
                to="/access"
                style={{
                  fontFamily: 'var(--wft-mono)',
                  fontSize: '10.5px',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                }}
              >
                Self-host instead
              </Link>{' '}
              <Link
                to="/"
                style={{
                  fontFamily: 'var(--wft-mono)',
                  fontSize: '10.5px',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  color: 'var(--wft-ink-2)',
                }}
              >
                Back to site
              </Link>
            </div>{' '}
            <p
              style={{
                fontFamily: 'var(--wft-mono)',
                fontSize: '9.5px',
                lineHeight: '1.7',
                color: 'var(--wft-ink-3)',
                margin: '26px 0 0',
                borderTop: '1px solid var(--wft-line)',
                paddingTop: '14px',
              }}
            >
              Demo: any valid email with a password of six characters or more opens the terminal. No
              credentials leave this page.
            </p>
          </form>
        </div>
      </div>
    </>
  );
}
